import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import './styles.css';

class LoginForgot extends Component {

    state = {
        load: false,
        statusPost: false,
        statusPostError: false,
        hash: false
    }

    componentDidMount() {

        const { hash } = this.props.match.params;
        if (hash) {
            this.setState({ hash });
        }

    }

    changePassword = async () => {
        const email = document.getElementById('email').value;
        this.setState({ load: true, statusPost: false, statusPostError: false });

        await api.post(`/auth/request-change-password`, {
            email
        }).then((result) => {
            if (result && result.data) {
                this.setState({ statusPost: result.data.msg });
                document.getElementById('email').value = '';
            }else{
                this.setState({ statusPost: 'Erro. Tente novamente!' });
            }
        }).catch(error => {
            let errors = error.response.data;
            this.setState({ statusPostError: (errors.msg) ? errors.msg : errors.errors[0].msg });
        });

        this.setState({ load: false });
    }

    changePasswordOk = async () => {
        const password = document.getElementById('password').value;
        this.setState({ load: true, statusPost: false, statusPostError: false });

        await api.put(`/auth/user/${this.state.hash}`, {
            password
        }).then((result) => {
            this.setState({ statusPost: result.data.msg });
            document.getElementById('password').value = '';
        }).catch(error => {
            let errors = error.response.data;
            this.setState({ statusPostError: (errors.msg) ? errors.msg : errors.errors[0].msg });
        });

        this.setState({ load: false });
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Esqueceu a Senha
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <form action="javascript:void(0)" id="formCompany">
                    {(!this.state.hash) ?
                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-info">
                                    Após colocar o email e solicitar uma nova senha será enviado um email para validação.
                            </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <h5>Email</h5>
                                    <input type="text" id="email" className='form-control form-control-success' />
                                    <br /><br />
                                    <button disabled={this.state.load} onClick={this.changePassword} className="btn btn-success"> <i className="fa fa-check"></i> Solicitar nova senha</button>
                                </div>
                            </div>

                            <div className="col-md-12">
                                {(this.state.statusPost) ?
                                    <div className="alert alert-success">
                                        {this.state.statusPost}
                                    </div>
                                    : null}

                                {(this.state.statusPostError) ?
                                    <div className="alert alert-danger">
                                        {this.state.statusPostError}
                                    </div>
                                    : null}
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <h5>Digite sua nova senha</h5>
                                    <input type="password" id="password" className='form-control form-control-success' />
                                    <br /><br />
                                    <button disabled={this.state.load} onClick={this.changePasswordOk} className="btn btn-success"> <i className="fa fa-check"></i> Alterar</button>
                                </div>
                            </div>

                            <div className="col-md-12">
                                {(this.state.statusPost) ?
                                    <div className="alert alert-success">
                                        {this.state.statusPost}
                                    </div>
                                    : null}

                                {(this.state.statusPostError) ?
                                    <div className="alert alert-danger">
                                        {this.state.statusPostError}
                                    </div>
                                    : null}
                            </div>
                        </div>
                    }
                </form>

            </Fragment >
        )
    }

}

export default LoginForgot;